import { render, staticRenderFns } from "./RegisterDownload.vue?vue&type=template&id=19d400f7&scoped=true"
import script from "./RegisterDownload.vue?vue&type=script&lang=js"
export * from "./RegisterDownload.vue?vue&type=script&lang=js"
import style0 from "./RegisterDownload.vue?vue&type=style&index=0&id=19d400f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d400f7",
  null
  
)

export default component.exports